<template>
  <v-dialog
    v-model="nachricht.show"
    width="50%"
    :fullscreen="$vuetify.breakpoint.smAndDown"
    persistent
    scrollable
  >
    <v-card>
      <v-card-title :class="nachricht.typ === 'error' ? 'orange darken-3 white--text' : ''">
        {{ nachricht.titel ? nachricht.titel : 'Meldung' }}
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text v-if="nachricht.nachricht">
        {{ nachricht.nachricht }}
      </v-card-text>
      <v-card-text v-if="nachricht.error">
        {{ nachricht.error }}
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn @click="close()" text>Schließen</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
  export default {
    computed: {
      nachricht () {
        return this.$store.state.nachricht
      }
    },
    methods: {
      close () {
        this.$store.state.nachricht.show = false
      }
    }
  }
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// dialogNachricht.vue?0cb9baa4